export default {
    roles: (state) => state.roles,
    defaults: (state) => state.defaults,
    loading: (state) => state.loading
}
